/** Curated SEO cross-link graph for high-value pages. */
export const RELATED_PAGE_SLUGS: Record<string, string[]> = {
  "career-astrology": [
    "free-kundali",
    "career-astrology-consultation",
    "dasha-calculator",
    "ai-astrologer",
    "sade-sati",
    "free-astrology-chat",
  ],
  "free-kundali": [
    "ai-astrologer",
    "free-astrology-chat",
    "nakshatra-calculator",
    "rashi-calculator",
    "kundli-matching",
    "kaal-sarp-dosha",
    "sade-sati",
    "mangal-dosha-calculator",
    "dasha-calculator",
    "ascendant-calculator",
  ],
  "birth-chart": [
    "free-kundali",
    "ai-astrologer",
    "nakshatra-calculator",
    "rashi-calculator",
    "dasha-calculator",
  ],
  "ai-kundli": ["free-kundali", "ai-astrologer", "nakshatra-calculator", "dasha-calculator"],
  nakshatra: [
    "nakshatra-calculator",
    "free-kundali",
    "rashi-calculator",
    "dasha-calculator",
    "baby-names",
  ],
  "nakshatra-calculator": [
    "nakshatra",
    "free-kundali",
    "rashi-calculator",
    "dasha-calculator",
    "baby-names",
  ],
  rashi: [
    "rashi-calculator",
    "free-kundali",
    "dasha-calculator",
    "ascendant-calculator",
    "rashifal",
    "kundli-matching",
    "compatibility",
  ],
  "rashi-calculator": [
    "rashi",
    "nakshatra-calculator",
    "free-kundali",
    "kundli-matching",
    "compatibility",
  ],
  compatibility: [
    "kundli-matching",
    "gun-milan",
    "free-kundali",
    "dasha-calculator",
    "mangal-dosha-calculator",
    "rashifal",
  ],
  "kundli-matching": [
    "gun-milan",
    "free-kundali",
    "compatibility",
    "mangal-dosha-calculator",
    "ai-astrologer",
  ],
  "gun-milan": ["kundli-matching", "free-kundali", "compatibility", "mangal-dosha-calculator"],
  "mangal-dosha-calculator": [
    "kundli-matching",
    "gun-milan",
    "kaal-sarp-dosha",
    "remedies",
    "free-kundali",
  ],
  rashifal: [
    "panchang",
    "choghadiya",
    "free-kundali",
    "rashi-calculator",
    "muhurat",
    "weekly-rashifal",
  ],
  "weekly-rashifal": [
    "rashifal",
    "monthly-rashifal",
    "panchang",
    "free-kundali",
    "rashi-calculator",
  ],
  "monthly-rashifal": [
    "rashifal",
    "weekly-rashifal",
    "panchang",
    "free-kundali",
    "rashi-calculator",
  ],
  choghadiya: ["muhurat", "rahu-kaal", "panchang", "calendar", "rashifal"],
  panchang: ["choghadiya", "muhurat", "rahu-kaal", "calendar", "rashifal"],
  muhurat: ["choghadiya", "rahu-kaal", "panchang", "mangal-dosha-calculator", "calendar"],
  "rahu-kaal": ["choghadiya", "muhurat", "panchang", "calendar"],
  "tithi-today": ["panchang", "choghadiya", "muhurat", "rahu-kaal", "calendar"],
  calendar: ["panchang", "choghadiya", "muhurat", "rahu-kaal", "rashifal"],
  "dasha-calculator": [
    "free-kundali",
    "nakshatra-calculator",
    "ascendant-calculator",
    "rashifal",
    "transits",
  ],
  "ascendant-calculator": [
    "free-kundali",
    "dasha-calculator",
    "nakshatra-calculator",
    "rashi-calculator",
  ],
  numerology: [
    "name-numerology",
    "free-kundali",
    "rashi-calculator",
    "nakshatra-calculator",
    "baby-names",
  ],
  "name-numerology": ["numerology", "free-kundali", "baby-names", "nakshatra-calculator"],
  "baby-names": ["nakshatra", "nakshatra-calculator", "numerology", "name-numerology"],
  "kaal-sarp-dosha": [
    "remedies",
    "free-kundali",
    "pitra-dosha",
    "sade-sati",
    "mangal-dosha-calculator",
  ],
  "pitra-dosha": ["remedies", "free-kundali", "kaal-sarp-dosha", "sade-sati"],
  "pitra-dosh-calculator": ["pitra-dosha", "sade-sati", "free-kundali", "remedies"],
  "nadi-astrology": ["kundli-matching", "mangal-dosha-calculator", "gun-milan", "free-kundali"],
  "shani-transit": ["sade-sati", "transits", "remedies", "rashifal", "free-kundali"],
  "sade-sati": [
    "shani-transit",
    "remedies",
    "free-kundali",
    "kaal-sarp-dosha",
    "pitra-dosha",
    "rashifal",
  ],
  remedies: [
    "upay",
    "kaal-sarp-dosha",
    "pitra-dosha",
    "sade-sati",
    "mangal-dosha-calculator",
    "free-kundali",
  ],
  upay: ["remedies", "kaal-sarp-dosha", "pitra-dosha", "lal-kitab", "free-kundali", "sade-sati"],
  "ai-astrologer": [
    "free-kundali",
    "free-astrology-chat",
    "rashifal",
    "kundli-matching",
    "sade-sati",
    "kaal-sarp-dosha",
    "remedies",
  ],
  "free-astrology-chat": [
    "ai-astrologer",
    "free-kundali",
    "rashifal",
    "kundli-matching",
    "sade-sati",
    "pitra-dosha",
    "remedies",
    "upay",
  ],
  transits: ["dasha-calculator", "free-kundali", "rashifal", "panchang"],
  "lal-kitab": ["remedies", "free-kundali", "kaal-sarp-dosha", "pitra-dosha"],
  prashna: ["free-kundali", "ai-astrologer", "rashifal", "muhurat"],
  tarot: ["rashifal", "free-kundali", "ai-astrologer", "panchang"],
  yoga: ["free-kundali", "nakshatra-calculator", "rashifal", "dasha-calculator"],
  varshphal: ["free-kundali", "dasha-calculator", "rashifal", "transits"],
  "kp-astrology": ["free-kundali", "nakshatra-calculator", "dasha-calculator"],
  vastu: ["remedies", "free-kundali", "lal-kitab"],
  ashtakvarga: ["free-kundali", "dasha-calculator", "transits"],
};
